var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseForm',{attrs:{"on-success":_vm.onSuccess}},[_c('b-card',[_c('SchoolListsBaseFormHeader',{attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2),_vm._t("default"),(
          _vm.account &&
          !(_vm.account.role === 'TEACHER' && _vm.schoolList.status !== 'DRAFT')
        )?_c('SchoolListsBaseFormFooter',{attrs:{"slot":"footer","readonly":_vm.readonly},slot:"footer"}):_vm._e()],2)],1),_vm._t("categories")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }